export class Report {
    type?: number;
    startDate?: string | null;
    endDate?: string | null;
    siteId?: string | null;
    companyId?: string | null;
    materialId?: string | null;
    year?: number;
    constructor(report?: Report) {
        this.type = report?.type;
        this.startDate = report?.startDate;
        this.endDate = report?.endDate;
        this.siteId = report?.siteId;
        this.companyId = report?.companyId;
        this.materialId = report?.materialId;
        this.year = report?.year;
    }
}
